import { memo } from "react";

const LogoHeaderComponent = ({ ...props }: { className?: string }) => {
  return (
    <img
      {...props}
      loading="lazy"
      decoding="async"
      fetchPriority="low"
      alt="ProjectSG Logo"
      // ProjectSG logo header from production s3
      src="https://d3h1y9jvvpl9bt.cloudfront.net/assets/images/61485578-8cbe-4015-9571-5dcec9541168/logo-header-nav-bar-1280w.webp"
    />
  );
};

const LogoHeader = memo(LogoHeaderComponent, () => {
  //never re-render
  return true;
});

export default LogoHeader;
